import { PaletteOptions } from "@mui/material";

import { customPalette } from "./custom.palette";

import { ThemeVariants } from "@store/customTheme";
import { CustomPalette } from "@type/CustomPalette";

declare module "@mui/material/styles" {
  interface Palette extends CustomPalette {}
  interface PaletteOptions extends CustomPalette {}
}

const palette = (color?: ThemeVariants): PaletteOptions & CustomPalette => {
  const useDefaultColor = !color || color === "default";

  return {
    divider: "#00000014",
    background: {
      default: "#F5F5F5",
    },
    primary: {
      main: useDefaultColor
        ? customPalette.purple[400]
        : customPalette[color]?.[400] || customPalette.purple[400],
      dark: useDefaultColor
        ? customPalette.purple[800]
        : customPalette[color]?.[800] || customPalette.purple[800],
      contrastText: useDefaultColor
        ? customPalette.purple[50]
        : customPalette[color]?.[50] || customPalette.purple[50],
    },
    secondary: {
      main: "#FFFFFF",
      dark: "#26262680",
      contrastText: "#262626",
    },
    text: {
      primary: "#000000DE",
      secondary: "#777777",
    },
    main: useDefaultColor
      ? customPalette.navy
      : customPalette[color] || customPalette.navy,
    custom: customPalette,
  };
};

export default palette;
